import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings } from '../../../misc';

const TelusBusinessWifi = ({ telusBusinessWifi }) => {
    const {
        quoteSummary: {
            products: { telusBusinessWifi: labelTelusBusinessWifi },
            table: { qty, oneTimeCharges, monthlyCharges, total }
        }
    } = getLocalizedStrings();
    const {
        totalMonthly,
        wifiAccess,
        totalOneTime
    } = telusBusinessWifi || {};

    return (
        <>
            {telusBusinessWifi && (
                <div style={{ overflowX: 'auto' }}>
                    <Heading level="h3">{`${labelTelusBusinessWifi}`}</Heading>
                    <br />
                    <table>
                        <thead>
                            <tr>
                                <th width="60%"></th>
                                <th>{qty}</th>
                                <th>{oneTimeCharges}</th>
                                <th>{monthlyCharges}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {wifiAccess &&
                                wifiAccess.length > 0 &&
                                wifiAccess.map(
                                    ({
                                        value: roValue,
                                        qty: roQty,
                                        prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                                    }) => (
                                            <tr key={`WifiAccess${roValue}`}>
                                                <td>
                                                    {`Wifi Access`}: {roValue}
                                                </td>
                                                <td>{roQty}</td>
                                                <td>{formatPrice(roOneTime)}</td>
                                                <td>{formatPrice(roMonthly)}</td>
                                            </tr>
                                        )
                                )}
                            <tr>
                                <td>{total}</td>
                                <td></td>
                                <td>{formatPrice(totalOneTime)}</td>
                                <td>{formatPrice(totalMonthly)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

TelusBusinessWifi.defaultProps = {
    telusBusinessWifi: {}
};

TelusBusinessWifi.propTypes = {
    telusBusinessWifi: PropTypes.objectOf(PropTypes.any)
};

export default TelusBusinessWifi;
